
const getVersionParts = versionString => {
  const versionParts = versionString.split('.');

  let dateSplitIndex = 2;
  if (versionParts[3].length === 3)
    dateSplitIndex = 1;
  const month = versionParts[3].substr(0,dateSplitIndex);
  const day = versionParts[3].substr(dateSplitIndex,2);

  return {
    majorVersion: versionParts[0],
    minorVersion: versionParts[1],
    build: versionParts[2],
    month: month,
    day: day,
    versionString: versionString
  }
};

const isLatestVersion = (versionString, latestVersionString) => {
  const versionData = getVersionParts(versionString);
  const latestVersionData = getVersionParts(latestVersionString);

  if (parseInt(versionData.month) === parseInt(latestVersionData.month) && parseInt(versionData.day) < parseInt(latestVersionData.day))
    return false;

  return (
    parseInt(versionData.majorVersion) >= parseInt(latestVersionData.majorVersion)
    &&
    parseInt(versionData.minorVersion) >= parseInt(latestVersionData.minorVersion)
    &&
    parseInt(versionData.build) >= parseInt(latestVersionData.build)
    &&
    parseInt(versionData.month) >= parseInt(latestVersionData.month)
  );
};

const isVersionStringValid = versionString => {
  if (versionString === undefined || versionString === null || versionString === "")
    return false;
  let versionParts = versionString.split('.');
  if (versionParts.length !==4)
    return false;

  return (!isNaN(versionParts[0]) || !isNaN(versionParts[1]) || !isNaN(versionParts[2]) || !isNaN(versionParts[3]));
};

const Version = (versionString, latestVersionString) => {

  let isValid = isVersionStringValid(versionString);

  if (isValid) {
    let versionData = getVersionParts(versionString);
    versionData.isLatest = isLatestVersion(versionString, latestVersionString);
    return versionData;
  }
  else {
    return {
      majorVersion: null,
      minorVersion: null,
      build: null,
      month: null,
      day: null,
      versionString: "",
      isLatest: null
    };
  }
};

export default Version;
